import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import img from "./logo"; // Ensure you have this logo import working or use a placeholder

const generateEstimatePDF = ({ customer, jobDetails, items, total, discountAmount, description, estimateNo, includeGst = false }, action = "download") => {

  const finalDiscount = parseFloat(discountAmount || 0);
  const netTotal = parseFloat(total || 0) - finalDiscount;

  const doc = new jsPDF();

  // 1. Logo & Header
  // ---------------------------------------------------------
  doc.addImage(img, "PNG", 14, 10, 20, 30); // (x, y, width, height)

  doc.setFontSize(12);
  doc.text("AVANTICA PUMPS PVT. LTD.", 200 - 14, 15, { align: "right" });
  doc.setFontSize(8);
  doc.text("PLOT NO. 75/2, AT. MAGHASAR, Nr. NAVJIVAN HOTEL,", 200 - 14, 20, { align: "right" });
  doc.text("Behind IOCL PETROL PUMP, Halol, Gujarat 389350", 200 - 14, 25, { align: "right" });
  doc.text("Phone: +91 7984042112  |  +91 9998546224", 200 - 14, 30, { align: "right" });
  doc.text("Email: sales@avanticapumps.com", 200 - 14, 35, { align: "right" });
  doc.text("Website: www.avanticapumps.com", 200 - 14, 40, { align: "right" });

  doc.setLineWidth(0.5);
  doc.line(14, 45, 196, 45);

  // 2. Title and metadata
  // ---------------------------------------------------------
  doc.setFontSize(12); // Reduced from 16
  doc.setFont("helvetica", "bold");
  
  const title = estimateNo ? `REPAIR ESTIMATE: ${estimateNo}` : "REPAIR ESTIMATE";
  doc.text(title, 105, 55, { align: "center" });

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  // Left Column: Customer Details
  let leftY = 65;
  doc.text(`Customer: ${customer.name}`, 14, leftY);
  doc.text(`City: ${customer.city}`, 14, leftY + 6);
  doc.text(`Mobile: ${customer.mobile}`, 14, leftY + 12);
  
  // Right Column: Job Details
  doc.text(`Date: ${customer.date}`, 140, leftY);
  doc.text(`Job Card No: ${jobDetails.jobCardNo || "-"}`, 140, leftY + 6);
  
  // Motor Details (Shifted here)
  doc.setFont("helvetica", "bold");
  doc.text("Motor Details:", 140, leftY + 14); // Header
  doc.setFont("helvetica", "normal");
  
  const detailsText = [
    `HP: ${jobDetails.hp || "-"}`,
    `Type: ${jobDetails.type || "-"}`
  ].join("  |  ");
  doc.text(detailsText, 140, leftY + 20);

  // 4. Items Table
  // ---------------------------------------------------------
  const tableStartY = leftY + 35; // approx 100 (65 + 35)

  const tableRows = items
    .filter(item => item.name && item.name.trim() !== "")
    .map((item, index) => {
      const price = parseFloat(item.price) || 0;
      const qty = parseFloat(item.quantity) || 0;
      return [
        index + 1,
        item.description ? `${item.name}\n(${item.description})` : item.name,
        Math.round(includeGst ? price / 1.18 : price),
        item.quantity,
        Math.round((includeGst ? price / 1.18 : price) * qty)
      ];
    });

  autoTable(doc, {
    head: [["#", "Description", "Rate", "Qty", "Amount"]],
    body: tableRows,
    startY: tableStartY,
    theme: "striped",
    headStyles: {
      fillColor: [59, 7, 100], // Purple-ish dark
      textColor: [255, 255, 255],
      fontStyle: 'bold',
    },
    bodyStyles: {
        fontSize: 10,
        textColor: [0, 0, 0]
    },
    columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 'auto' }, // Description
        2: { cellWidth: 25, halign: 'right' },
        3: { cellWidth: 20, halign: 'center' },
        4: { cellWidth: 30, halign: 'right' }
    }
  });

  // 5. Totals
  // ---------------------------------------------------------
  let finalY = doc.lastAutoTable.finalY + 10;
  
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");

  if (includeGst) {
      const taxableAmount = netTotal / 1.18;
      const totalGst = netTotal - taxableAmount;
      const cgst = totalGst / 2;
      const sgst = totalGst / 2;

      if (finalDiscount > 0) {
          doc.text(`Discount: -${finalDiscount.toFixed(2)}`, 196, finalY, { align: "right" });
          finalY += 7;
      }
      
      doc.text(`Taxable Amount: ${taxableAmount.toFixed(2)}`, 196, finalY, { align: "right" });
      finalY += 7;
      doc.text(`CGST (9%): ${cgst.toFixed(2)}`, 196, finalY, { align: "right" });
      finalY += 7;
      doc.text(`SGST (9%): ${sgst.toFixed(2)}`, 196, finalY, { align: "right" });
      finalY += 8;
  } else {
      doc.text(`Total Amount: ${total.toFixed(2)}`, 196, finalY, { align: "right" });
      finalY += 7;
      if (finalDiscount > 0) {
          doc.text(`Discount: -${finalDiscount.toFixed(2)}`, 196, finalY, { align: "right" });
          finalY += 7;
      }
      finalY += 1;
  }

  doc.setFontSize(14);
  doc.text(`Net Payable: ${netTotal.toFixed(2)}`, 196, finalY, { align: "right" });

  // 6. Notes / Description Box
  // ---------------------------------------------------------
  if (description) {
      finalY += 15;
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Notes / Techno-Commercial Description:", 14, finalY);
      
      doc.setFont("helvetica", "normal");
      const splitDesc = doc.splitTextToSize(description, 180);
      doc.text(splitDesc, 14, finalY + 6);
      
      finalY += (splitDesc.length * 5) + 5;
  } else {
      finalY += 20;
  }

  // 7. Footer Signatures
  // ---------------------------------------------------------
  // Check if we have enough space, else add page
  if (finalY > 250) {
      doc.addPage();
      finalY = 20;
  } else {
      finalY += 10;
  }

  doc.setFontSize(10);
  doc.text("For Avantica Pumps Pvt. Ltd.", 14, finalY + 10);
  doc.text("Authorized Signatory", 14, finalY + 25);

  // Save
  // Output
  if (action === "print") {
      doc.autoPrint();
      window.open(doc.output('bloburl'), '_blank');
  } else {
      doc.save(`Estimate_${jobDetails.jobCardNo || customer.name}_${customer.date}.pdf`);
  }
};

export default generateEstimatePDF;
